import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";

import PrintTable from "../common/PrintTable";
import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";

const ExpenseAccounts = (props) => {
  const [data, setData] = useState([]);
  const { tid, aid, halfYearId } = props.match.params;

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "budget_code",
      label: "کد بودجه",
    },
    {
      path: "name",
      label: "نام",
    },
    {
      path: "budget",
      label: "بودجه",
    },
    { path: "paid", label: "پرداخت شده" },
    {
      path: "balance",
      label: "باقیمانده",
    },
  ];

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `expenses/types/${tid}/accounts/${aid}/subAccounts?halfYearId=${halfYearId}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        title={data?.summary?.title}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
      <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء تایید کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء پرداخت کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء گیرنده</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ExpenseAccounts;
